import React, { useRef, useState, useEffect } from 'react';
import "@aws-amplify/ui-react/styles.css";
//import "semantic-ui-css/semantic.min.css"
import { Link, useNavigate} from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react'
import { Hub } from 'aws-amplify';

import appLogo from "./images/workgpt_128.png";
import createContentDemo from "./images/createContent.gif"
import editContentDemo from "./images/editContent.gif"

//import {LANGUAGE_MAP} from "./utils/LanguageMap.js";
import * as AuthUtils from './utils/AuthUtils.js';
import * as ReactUtils from "./utils/ReactUtils.js";
import * as Utils from './utils/Utils.js';
import Footer from './ui_views/Footer';


const WORKGPT_CHROME_URL = 'https://chrome.google.com/webstore/detail/workgpt-gpt-for-work/aijkbfcgfacnbgaladlemlbonnddphdf';
const WORKGPT_FOR_WORKSPACE_URL= "https://workspace.google.com/marketplace/app/workgpt_gpt_chatgpt_for_workspace/368806015202";
const EMAIL_AI_URL = "https://workspace.google.com/marketplace/app/emailai_gpt_chatgpt_ai_for_email_and_gma/244071321454";
const TRANSLATE_GPT_FOR_WORKSPACE_URL = "https://aiworksuite.com/translator-with-gpt";
const CONTACT_US_URL = "https://www.aiworksuite.com/contact-us"

function listenToSignUpSignInEvents() {
  Hub.listen('auth', async (data) => {
    // eslint-disable-next-line default-case
    switch (data.payload.event) {
      case 'signIn':
          console.debug('user signed in', data.payload.data?.attributes?.email);
          try {
            let user = await AuthUtils.currentAuthenticatedUser();
            if (!user.attributes['custom:origin_platform']) {
              let result = await AuthUtils.updateUserAttributes(user, { 'custom:origin_platform': Utils.PLATFORM_TYPE.WEB });
              console.debug('User attributes updated:', result);
            }
          } catch (error) {
              console.error('Error updating user orgin platform attribute:', error);
          }
          break;
      case 'signUp':
        console.debug('user signed up', data.payload.data?.attributes?.email);
        break;
      case 'signOut':
        console.debug('user signed out');
          break;
      case 'signIn_failure':
          console.log('user sign in failed');
          break;
      case 'configured':
          console.log('the Auth module is configured');
    }
  });  
}

export const HomePage = () => {
  listenToSignUpSignInEvents();

  const [activePurchasePlanShown, setActivePurchasePlanShown] = useState(Utils.PURCHASE_PLAN.PREMIUM);
  const handlePurchasePlanShownItemClick = (event) => {
    //console.log("activePurchasePlanShown", event.target.id);
    setActivePurchasePlanShown(event.target.id);
  };



  const [isMenuSidebarOpen, setIsMenuSidebarOpen] = useState(false);
  const onMenuSidebarClick = () => {
    //console.log("onMenuSidebarClick get clicked");
    setIsMenuSidebarOpen(!isMenuSidebarOpen);
  }
  const sidebarMenuRef = useRef(null);
  const handleOutsideOfSidebarMenuClick = (event) => {
    //console.log("handleOutsideOfSidebarMenuClick get clicked", event.target.id);
    if (sidebarMenuRef.current && !sidebarMenuRef.current.contains(event.target) && event.target.id !== "sideBarMenuId") {
      setIsMenuSidebarOpen(false);
    }
  };

  const premiumSectionRef = useRef(null);
  const onScrollToPremiumSection = () => {
    premiumSectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const aboutSectionRef = useRef(null);
  const onScrollToAboutSection = () => {
    aboutSectionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const [isUserSignedIn, setIsUserSignedIn] = useState(false);
  const [isUserSubscribed, setIsUserSubscribed] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  useEffect(() => { 
    updateUserSignedInStateAndEmail(); 

    document.addEventListener('click', handleOutsideOfSidebarMenuClick);
    return () => {
      document.removeEventListener('click', handleOutsideOfSidebarMenuClick);
    };
  }, []);

  const updateUserSignedInStateAndEmail = async () => {
    const accessToken = await Utils.getUserAccesstoken();
    if (accessToken) {
      setIsUserSignedIn(true);

      const userInfo = await AuthUtils.currentUserInfo();
      if (userInfo?.attributes?.email) {
        setUserEmail(userInfo?.attributes?.email);
      }

      const subscriptionState = await Utils.getSubscriptionState();
      //console.log("subscription state", subscriptionState, Utils.isUserSubscribed(subscriptionState));
      setIsUserSubscribed(Utils.isUserSubscribed(subscriptionState));
    }
  };

  const onClickStartNow = async () => {
    window.location.href = "https://progpt.ai";
    // const $gptSection = document.getElementById("gptSectionId");
    // ReactUtils.showUserSignInOrOutPopup(null, $gptSection, true, updateUserSignedInStateAndEmail);
  }

  const onClickAIWorkspace = async () => {
    window.location.href = "https://workspace.google.com/marketplace/app/workgpt_gpt_chatgpt_for_workspace/368806015202?pann=b";
    // const $gptSection = document.getElementById("about-section");
    // ReactUtils.showUserSignInOrOutPopup(null, $gptSection, false, updateUserSignedInStateAndEmail);
  }

  const navigateToChromeExtension = () => {
    window.open(WORKGPT_CHROME_URL);
  };

  const navigateToURL= (url) => {
    window.open(url);
  };

  const cardCss = { backgroundColor: 'white', borderRadius: '16px', padding: '40px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '60px' };
  const headingCss = { fontSize: '36px', fontWeight: '700', color: '#0077ff', textAlign: 'center', marginBottom: '60px' };

  return (<div>
    <meta charSet="utf-8" />
    <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/water.css@2/out/water.css"></link>
    <title>WorkGPT: GPT for Workspace, GPT for Docs, GPT for Slides, GPT for Sheets, GPT for Gmail, GPT for Chrome</title>

    <style type="text/css">
      {Styles()}
    </style>

    {/* Your JavaScript script here */}
    {/* <script>
    </script> */}


  <div className={`ui vertical sidebar menu ${isMenuSidebarOpen ? 'visible' : ''}`} ref={sidebarMenuRef}>
    <a className="active item" href="https://www.aiworksuite.com">HOME</a>
    {/* <a className="item" onClick={onScrollToAboutSection}>ABOUT</a> */}
    {isUserSignedIn && (!isUserSubscribed) && <a className="item" onClick={onScrollToPremiumSection}>PREMIUM PLAN</a>}
    <a className="item" href={CONTACT_US_URL}>HELP CENTER</a> 
    { <a className="item" onClick={onClickStartNow}>START NOW</a> }
    { <a className="item" onClick={onClickAIWorkspace}>Use AI for Workspace</a> }
    <a className="item" onClick={onMenuSidebarClick} >CLOSE</a> 
  </div>

    <div className="ui container" >
      <div className="ui large secondary menu" style={{paddingBottom: '15px'}}>
        <a className="toc item">
          <i id = "sideBarMenuId" className="sidebar icon" onClick={onMenuSidebarClick}></i>
        </a>
        <div style={{ display: 'flex', alignItems: 'center', marginRight: '30px' }}>
          <img src={appLogo} alt="logo" style={{ width: '30px', height: '30px', marginRight: '8px' }} />
          <div style={{ fontSize: '19px', display: 'inline', fontWeight: '600', fontFamily: "Arial, sans-serif" }}>WorkGPT</div>
        </div>

        <a className="active item default-font-family" href="https://www.aiworksuite.com">Home</a>
        {/* <a className="item default-font-family" onClick={onScrollToAboutSection}>About</a> */}
        {isUserSignedIn && (!isUserSubscribed) && <a className="item default-font-family" onClick={onScrollToPremiumSection}>Premium Plan</a>}

        <Dropdown text='Products' item className="default-font-family">
          <Dropdown.Menu>
            <Dropdown.Item text='WorkGPT: GPT for Google Workspace' onClick={() => navigateToURL(WORKGPT_FOR_WORKSPACE_URL)} />
            <Dropdown.Item text='WorkGPT for Chrome' onClick={navigateToChromeExtension} />
            <Dropdown.Item text='EmailAI' onClick={() => navigateToURL(EMAIL_AI_URL)} />
            <Dropdown.Item text='TranslateGPT' onClick={() => navigateToURL(TRANSLATE_GPT_FOR_WORKSPACE_URL)} />
          </Dropdown.Menu>
        </Dropdown>

        <a className="item default-font-family" href={CONTACT_US_URL}>Help Center</a>

        { <a className="ui button" style={{ marginLeft: 'auto', backgroundColor: 'rgb(167, 52, 222)', color: 'white'}} onClick={onClickStartNow}>START NOW</a> }
        { <a className="ui button" style={{ marginLeft: '10px', backgroundColor: 'rgb(0, 119, 255)', color: 'white'}} onClick={onClickAIWorkspace}>Use AI for Workspace</a> }
        {/* { isUserSignedIn && <div style={{marginLeft: 'auto'}}>
              <button style={{ padding: '4px', marginTop: '5px', backgroundColor: 'white' }} data-tooltip="GPT History" 
                data-inverted="" data-variation="tiny" data-position="bottom center" onClick={onShowHistoryButtonClick}>
                <img src={historyImage} style={{ width: '18px' }} alt="" />
              </button>

            <Link to="/settings">
              <button id="settingsButtonId" style={{ padding: '4px', marginTop: '5px', backgroundColor: 'white' }} 
                data-tooltip="Settings" data-inverted="" data-variation="tiny" data-position="bottom center">
                <img id="settingsButtonImageId" src={settingsImage} style={{ width: '18px' }} alt="" />
              </button> 
            </Link>
          </div>} */}
      </div>
    </div>
    
    {/* SECTION ABOUT */}
    { <div>
      <div style={{backgroundColor: '#eef0fa'}}>
      <section id="about-section"></section>
      <div id="aboutSectionId" className="ui container" style={{paddingTop: '30px', paddingBottom: '60px'}} ref={aboutSectionRef}>
        {/* <h1 className="ui horizontal header divider" style={{fontSize: '35px', fontFamily: "Arial, sans-serif"}}>
          <img src={appLogo} alt="logo" style={{ width: '40px', height: '40px', marginLeft: '-10px', marginRight: '15px', marginTop: '-5px' }} />
          <a style={{marginTop: '20px'}} href="#">WorkGPT</a>
        </h1> */}
        {/* <h3 id="sloganLabel" style={{ fontFamily: "Georgia, serif", paddingTop: '0px', fontSize: '25px', textAlign: 'center', color: '#10a37f'}}>Work Smart</h3> */}
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 id="sloganLabel2" style={{ fontFamily: "'Inter', -apple-system, sans-serif", fontSize: '36px', fontWeight: '700', background: 'linear-gradient(135deg, #10a37f 0%, #0077ff 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', marginBottom: '20px', lineHeight: '1.2' }}>
            Boost Productivity and Efficiency with WorkGPT</h2>
          <h3 id="sloganLabel3" style={{ fontFamily: "'Inter', sans-serif", fontSize: '28px', fontWeight: '500', color: '#0077ff', marginBottom: '30px' }}>Deliver Great Results and Achieve Excellence by 10x!</h3>
        </div>

        <div style={{ ...cardCss, lineHeight: '1.8', fontSize: '16px', color: '#2d3748' }}>
          <p style={{ marginBottom: '20px' }}>
            <strong>Experience the power of WorkGPT</strong>, your ultimate AI companion for work! WorkGPT harnesses advanced AI technologies including ChatGPT GPT-5.1, Gemini Pro 3, Claude 4.5, Grok 4, DeepSeek and Meta Llama to provide unparalleled productivity and efficiency.
          </p>
          <p style={{ marginBottom: '20px' }}>
            Experience a <strong>10x improvement</strong> in your writing and editing tasks. Whether you need help creating content (emails, posts, updates), understanding complex information, or enhancing your work, WorkGPT has got you covered.
          </p>
          <p style={{ marginBottom: '20px' }}>
            <strong>Seamlessly integrate</strong> WorkGPT into your workflow. Available for Google Workspace applications (Docs, Slides, Sheets, Gmail), accessible through the web, and as a convenient Chrome extension.
          </p>
          <p style={{ marginBottom: '20px' }}>
            <strong>🔒 Privacy First:</strong> Your data and privacy are our top priority. We've implemented robust security measures to guarantee the confidentiality and protection of your information.
          </p>

          <div style={{ backgroundColor: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '8px', padding: '16px', marginTop: '24px' }}>
          So, why wait? Join the countless professionals who have already embraced the power of WorkGPT. Revolutionize your work, increase your efficiency, and unlock your true potential with the ultimate AI solution – WorkGPT.
          </div>
        </div>


        {/* Products */}
        <div id="productsSectionId" style={{paddingBottom:"80px"}}>
          <h2 style={{...headingCss,marginBottom:"40px"}}>WorkGPT Apps</h2>

          <div className="ui stackable equal height grid">

            {/* LEFT */}
            <div className="eight wide column">
              <div style={{borderRadius:"12px",overflow:"hidden",boxShadow:"0 6px 20px rgba(0,0,0,0.12)"}}>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/kjuXmwesVdM?si=k7k4u3ohYj6C0fae" title="Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{display:"block"}}/>
              </div>

              <div style={{marginTop:"30px"}}>
                <a href="https://www.producthunt.com/posts/workgpt?utm_source=badge-featured" target="_blank" rel="noopener noreferrer">
                  <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=411708&theme=light" alt="PH" style={{width:"250px",height:"54px"}}/>
                </a>
              </div>
            </div>

            {/* RIGHT */}
            <div className="eight wide column">
              <div style={{...cardCss, marginBottom: "10px", background:"#FFFBEA",padding:"32px",borderRadius:"14px",boxShadow:"0 6px 20px rgba(0,0,0,0.08)",height:"100%"}}>

                {/* 1 */}
                <div style={{marginBottom:"40px"}}>
                  <h3 style={{fontSize:"20px",fontWeight:600,marginBottom:"12px",color:"#1A202C"}}>1. WorkGPT for Google Workspace</h3>
                  <p style={{color:"#4A5568",fontSize:"15px",marginBottom:"20px"}}>Available for Docs, Slides, Sheets, and Gmail</p>
                  <a href="https://workspace.google.com/marketplace/app/workgpt_gpt_chatgpt_for_workspace/368806015202?pann=b" target="_blank" rel="noopener noreferrer">
                    <img src="https://workspace.google.com/static/img/marketplace/en/gwmBadge.svg?" alt="GWM Badge" style={{height:"68px",transition:"0.25s"}} onMouseOver={e=>e.currentTarget.style.transform="scale(1.06)"} onMouseOut={e=>e.currentTarget.style.transform="scale(1)"}/>
                  </a>
                </div>

                {/* 2 */}
                <div style={{marginBottom:"40px"}}>
                  <h3 style={{fontSize:"20px",fontWeight:600,marginBottom:"12px",color:"#1A202C"}}>2. Web App</h3>
                  <p style={{color:"#4A5568",fontSize:"15px",marginBottom:"20px"}}>Use WorkGPT in your browser</p>
                  <button onClick={onClickStartNow} style={{background:"linear-gradient(135deg,#0077ff,#0055cc)",border:"none",padding:"14px 32px",fontSize:"17px",fontWeight:600,color:"#fff",borderRadius:"10px",cursor:"pointer",transition:"0.2s",boxShadow:"0 5px 18px rgba(0,119,255,0.3)"}} onMouseOver={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 10px 28px rgba(0,119,255,0.4)"}} onMouseOut={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="0 5px 18px rgba(0,119,255,0.3)"}}>
                    <b>Use Now</b>
                  </button>
                </div>

                {/* 3 */}
                <div>
                  <h3 style={{fontSize:"20px",fontWeight:600,marginBottom:"12px",color:"#1A202C"}}>3. WorkGPT for Chrome</h3>
                  <p style={{color:"#4A5568",fontSize:"15px",marginBottom:"20px"}}>Use WorkGPT anywhere in Chrome</p>
                  <button onClick={navigateToChromeExtension} style={{background:"linear-gradient(135deg,#0077ff,#0055cc)",border:"none",padding:"14px 32px",fontSize:"17px",fontWeight:600,color:"#fff",borderRadius:"10px",cursor:"pointer",transition:"0.2s",boxShadow:"0 5px 18px rgba(0,119,255,0.3)"}} onMouseOver={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 10px 28px rgba(0,119,255,0.4)"}} onMouseOut={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="0 5px 18px rgba(0,119,255,0.3)"}}>
                    <b>Download for Free</b>
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      
        
        <h2 className="ui horizontal header" style={{color: 'rgb(0, 122, 255)', textAlign: 'center', marginBottom: '40px'}}>Features</h2>
        <div className="ui stackable equal height stackable grid" >
          <div className="eight wide column default-font" style={{paddingRight: '40px'}}>
            <b>General Assistance for your work and improving content:</b><br></br>
            <ul className="ui list">
                <li>Fix grammar and spelling </li>
                <li>Improve writing or rewrite with many tones supported (professional, friendly, formal, causal etc)! </li>
                <li>Elaborate</li>
                <li>Create tasks or to-do lists</li>
                <li>Offer suggestions to the content</li>
                <li>Provide different ways to say</li>
                <li>Expand and make longer, Shorten </li>
                <li>Reply to emails/questions/posts/comments with different tones</li>
                <li>Bulletize, format</li>
                <li>Provide suggestions or different ways to say</li>
                <li>Any other freeform prompt and command you want for GPT.</li>
            </ul>
          </div>
          <div className="eight wide column">
            <img style = {{marginTop: '40px'}} src={editContentDemo} alt="EditContent" />
          </div>
        </div>

        <div className="ui stackable equal height stackable grid" >
            <div className="eight wide column default-font"  style={{paddingRight: '40px'}}>
              <br></br>
              <b>Creating content: </b><br></br>
              <ul className="ui list">
                <li>Write emails</li>
                <li>Make notes</li>
                <li>Write SEO-optimized content or article</li>
                <li>Generate post for Linkedin or Facebook</li>
                <li>Create script for Youtube or Tiktok videos</li>
                <li>Generate images</li>
                <li>Compose status update or summary</li>
                <li>Create descriptions</li>
                <li>Create Slides </li>
                <li>Generate ideas</li>
                <li>Write for anything!</li>
              </ul>
            </div>
            <div className="eight wide column">
              <img style = {{marginTop: '60px'}} src={createContentDemo} alt="CreateContent" />
            </div>
        </div>
        <div className="default-font" style={{paddingTop: '40px'}}>It can also translate to different language, summarize content, help you understand, explain content, provide synonyms, 
          dictionary to help you understand and many more!</div>


        <h2 className="ui horizontal header" style={{color: 'rgb(0, 122, 255)', textAlign: 'center', marginTop: '100px', marginBottom: '40px'}}>
          How to use WorkGPT in Google Docs</h2>
        <div style={{ marginLeft: "auto", marginRight: "auto", width: '70%' }}>
          {/* see here for the responsive video frame, https://www.w3schools.com/howto/howto_css_responsive_iframes.asp */}
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/NiMm20bDuz0?si=xTATOqVu9sarHxyO" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
        </div>

        <h2 className="ui horizontal header" style={{color: 'rgb(0, 122, 255)', textAlign: 'center', marginTop: '100px', marginBottom: '40px'}}>
          AI for Google Sheets</h2>
        <div style={{ marginLeft: "auto", marginRight: "auto", width: '70%' }}>
          {/* see here for the responsive video frame, https://www.w3schools.com/howto/howto_css_responsive_iframes.asp */}
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/UdyUzhoVUd4?si=PNiYsZ6hWBCgVuII" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
        </div>

        <h2 className="ui horizontal header" style={{color: 'rgb(0, 122, 255)', textAlign: 'center', marginTop: '100px', marginBottom: '40px'}}>
          How to use WorkGPT in Gmail</h2>
        <div style={{ marginLeft: "auto", marginRight: "auto", width: '70%' }}>
          <div className="video-container">
            <iframe src="https://www.youtube.com/embed/FXnPhISKzNk?si=TH6KAOxCkEnw99tI" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
          </div>
        </div>

      </div>
      </div>
    </div> }
    
    {/* SECTION PREMIUM */}
    <section id="premium-plan-section"></section>
    { (!isUserSubscribed)  && <div id="premiumServiceSectionId" style={{backgroundColor: '#F8F8F8', paddingTop: '30px', paddingBottom: '30px'}} ref={premiumSectionRef}>
      <div className="ui container">
        <h1 className="ui horizontal header divider">
          <a href="#">{(activePurchasePlanShown === Utils.PURCHASE_PLAN.ENTERPRISE) ? "Enterprise Service" : 'Premium Service'}</a>
        </h1>
        <div id="NotUpgradedToPremiumService">
          <div className="centered">
            <div className="ui two item menu" id="workGPT_premiumPlanMenuId" style={{marginTop: '50px', width: '60%'}}>
              <a className={`item blue ${activePurchasePlanShown === Utils.PURCHASE_PLAN.PREMIUM ? 'active' : ''}`} 
                id = {Utils.PURCHASE_PLAN.PREMIUM} onClick={(event) => handlePurchasePlanShownItemClick(event)}>Premium Service</a>
              <a className={`item blue ${activePurchasePlanShown === Utils.PURCHASE_PLAN.ENTERPRISE ? 'active' : ''}`} 
                id = {Utils.PURCHASE_PLAN.ENTERPRISE} onClick={(event) => handlePurchasePlanShownItemClick(event)}>Enterprise Service</a>
            </div>
          </div>
          
          {ReactUtils.PurchaseUIElements(activePurchasePlanShown, userEmail)}
          <label style={{ paddingRight: '5px', color: 'gray', fontSize: '17px' }}>
            Have more questions, or want to purchase a license for a group of people or the whole team/company?
            Please contact us at <a href={CONTACT_US_URL}>aiworksuite.com/contact-us</a>.
            We are happy to answer your questions or discuss related offers.
          </label>
        </div>
      </div>
    </div> }

    <Footer></Footer>

  </div>
  );
}

const Styles = () => (
  <style>
    {`
      body {
        max-width: 100%; !important;
        padding: 0px;
      }

      .video-container {
        position: relative;
        width: 100%;
        height: '0';
        padding-bottom: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
      }

      .default-font {
        font-size: 19px;
        font-family: Helvetica, arial, sans-serif; 
      }

      .default-font-family {
        font-family: Helvetica, arial, sans-serif; 
      }
      
      /* Then style the iframe to fit in the container div with full height and width */
      .video-container iframe {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .centered {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .translation-button {
        background-color: rgb(0, 119, 255);
        color: white;
        min-width: 150px;
        height: 40px;
      }

      .hidden.menu {
        display: none;
      }

      .masthead.segment {
        min-height: 700px;
        padding: 1em 0em;
      }
      .masthead .logo.item img {
        margin-right: 1em;
      }
      .masthead .ui.menu .ui.button {
        margin-left: 0.5em;
      }
      .masthead h1.ui.header {
        margin-top: 3em;
        margin-bottom: 0em;
        font-size: 4em;
        font-weight: normal;
      }
      .masthead h2 {
        font-size: 1.7em;
        font-weight: normal;
      }

      .ui.vertical.stripe {
        padding: 8em 0em;
      }
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .ui.vertical.stripe .button + h3,
      .ui.vertical.stripe p + h3 {
        margin-top: 3em;
      }
      .ui.vertical.stripe .floated.image {
        clear: both;
      }
      .ui.vertical.stripe p {
        font-size: 1.33em;
      }
      .ui.vertical.stripe .horizontal.divider {
        margin: 3em 0em;
      }

      .quote.stripe.segment {
        padding: 0em;
      }
      .quote.stripe.segment .grid .column {
        padding-top: 5em;
        padding-bottom: 5em;
      }

      .footer.segment {
        padding: 5em 0em;
      }

      .secondary.pointing.menu .toc.item {
        display: none;
      }

      .custom-textarea {
        min-width: 450px !important; /* Adjust the value as needed */
      }

      .custom-marginleft {
        margin-left: 60px; !important;
      }

      .suggestions-container {
        border: 1px solid #ccc;
        padding: 5px;
        position: absolute;
        background-color: white;
        width: 300px;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        z-index: 1000;
      }
      
      .suggestions-container ul {
          list-style: none;
          padding: 0;
          margin: 0;
      }
      
      .suggestions-container li {
          padding: 5px;
          cursor: pointer;
      }
      
      .suggestions-container li:hover {
          background-color: #f0f0f0;
      }

      @media only screen and (max-width: 700px) {
        .ui.fixed.menu {
          display: none !important;
        }
        .secondary.large.menu .item,
        .secondary.large.menu .button,
        .secondary.large.menu .menu {
          display: none;
        }
        .secondary.large.menu .toc.item {
          display: block;
        }
        .masthead.segment {
          min-height: 350px;
        }
        .masthead h1.ui.header {
          font-size: 2em;
          margin-top: 1.5em;
        }
        .masthead h2 {
          margin-top: 0.5em;
          font-size: 1.5em;
        }

        .custom-textarea {
          /* Default height for larger screens */
          min-width: 100% !important;
        }

        .custom-marginleft {
          margin-left: 0px;
        }
      }
    `}
  </style>
);


/* 
1. Create Content suggestions and more prompts (Done)
2. Sign up with Google (Done)
3. Todo: add create images functionality 

  } else if (request[utils.MESSAGE_TYPE_KEY] == utils.MESSAGE_TYPE.GPT_CREATE_IMAGE) {
    (async () => {
      try {
        if (request[utils.SEND_MESSAGE_GPT_PROMPT]) {  
          const requestData = {
            prompt: request[utils.SEND_MESSAGE_GPT_PROMPT],
            type: GPT_REQUEST_TYPE.CREATE_IMAGE,
            imageSize: request[utils.SEND_MESSAGE_IMAGE_SIZE],
            accessToken: request[utils.SEND_MESSAGE_ACCESS_TOKEN],
            surface: utils.SURFACE_TYPE.CHROME_EXT,
          };

          const response = await awsClient.fetch(`${ASK_GPT_URL}/my-lambda/invocations`, 
            { body: JSON.stringify(requestData) });
          const gptResponse = await response.json();

          console.log("gpt create image response is", gptResponse);
          sendResponse({[utils.SEND_MESSAGE_RESPONSE]: gptResponse.imageURL});
        } else {
          console.error("gpt create image prompt is null", JSON.stringify(request));
        }
      } catch(error) {
        console.error("Create image prompt failed");
        sendResponse({[utils.SEND_MESSAGE_ERROR_RESPONSE]: "Create image failed: " + error.message});
      }
    })();

4. Show GPT-4


*/
